const termsConstants = {
  array: [
    {
      key: 'Privacy Policy',
      link:
        'https://drive.google.com/file/d/1nNaKMon4UBk5ZOFTMGaHqdsNjQeHtXQ7/view?usp=drive_link',
    },
    {
      key: 'Data Retention Policy',
      link:
        'https://drive.google.com/file/d/1-WCK4AmiR7qUxIl0j9QHTGf3VKQwfhue/view?usp=drive_link',
    },
    {
      key: 'Breach Notification Policy',
      link:
        'https://drive.google.com/file/d/1kSoUlru-mIqBM9n-t0YFzc7HlolW1hAw/view?usp=drive_link',
    },
  ],
  title: 'Terms and Conditions',
  effectiveDateTitle: 'Effective Date',
  lastUpdtedTitle: 'Last Updated',
  effectiveDate: '01 Jul 2024',
  lastUpdated: '28 Feb 2025',
  sections: [
    {
      title: '1. Introduction',
      content:
        'Welcome to Homa Health. By accessing or using our platform, you agree to be bound by these Terms and Conditions and our Privacy Policy. If you do not agree with any part of these terms, you should not proceed with using the platform.',
    },
    {
      title: '2. Eligibility and Account Registration',
      points: [
        'You must be at least 18 years old to use this platform.',
        'You are required to provide accurate and complete registration details.',
        'You are responsible for maintaining the confidentiality of your login credentials.',
        'If we detect any fraudulent, unauthorized, or illegal activity, your account may be suspended or terminated.',
      ],
    },
    {
      title: '3. Privacy and Data Protection',
      points: [
        'We are committed to protecting your privacy and complying with applicable HIPAA and data protection laws.',
        'Our Privacy Policy outlines how we collect, use, and share your data.',
        'You have the right to access, modify, or delete your personal information as per our Data Retention Policy.',
        'Unauthorized access or misuse of user data is strictly prohibited.',
      ],
    },
    {
      title: '4. User Responsibilities and Conduct',
      dos: [
        'By using this platform, you agree to:',
        'Provide accurate and truthful information.',
        'Use the platform for lawful purposes only.',
        'Report any suspicious or unauthorized activity immediately.',
      ],
      donts: [
        'You are strictly prohibited from:',
        'Sharing your login credentials.',
        'Attempting to hack, disrupt, or gain unauthorized access to the system.',
        'Uploading or sharing any content that is illegal, harmful, or violates privacy rights.',
      ],
    },
    {
      title: '5. Intellectual Property Rights',
      points: [
        'All content, trademarks, logos, and intellectual property on this platform belong to Homa Health Solutions Inc.',
        'You may not copy, modify, distribute, or commercially exploit any content without explicit permission.',
      ],
    },
    {
      title: '6. Compliance with Laws',
      points: [
        'You agree to comply with all applicable laws and regulations, including those related to healthcare and data privacy (HIPAA, SOC2, etc.). ',
        'Violations may result in account suspension or legal action.',
      ],
    },
    {
      title: '7. Security Measures',
      points: [
        'We implement industry-standard security measures to protect user data.',
        'In case of a data breach, we follow our Breach Notification Policy to notify affected users as required by law.',
        'You are responsible for maintaining the security of your login credentials.',
      ],
    },
    {
      title: '8. Amendments to the Terms',
      points: [
        'We reserve the right to update or modify these Terms and Conditions at any time.',
        'Users will be notified of significant changes, and continued use of the platform constitutes acceptance of the updated terms.',
      ],
    },
    {
      title: '9. Account Termination and Deactivation',
      points: [
        'We may suspend or terminate your account if you violate these terms or engage in unauthorized activity.',
        'Users can voluntarily deactivate their accounts by following the instructions in their account settings.',
        'Once an account is closed, data is retained as per our Data Retention Policy before permanent deletion.',
      ],
    },
    {
      title: '10. Dispute Resolution',
      points: [
        'Any disputes arising from the use of this platform will be resolved through arbitration or mediation before taking legal action. ',
        'The governing law and jurisdiction for any disputes shall be the State of Texas, USA.',
      ],
    },
    {
      title: '11. Limitation of Liability and Disclaimers',
      points: [
        'Homa Health Solutions Inc provides the platform "as is" without any warranties of accuracy, availability, or fitness for a particular purpose.',
        'We are not responsible for user-generated content, third-party links, or any unauthorized actions of other users.',
        'To the fullest extent permitted by law, we are not liable for indirect, incidental, or consequential damages arising from platform use.',
      ],
    },
    {
      title: '12. User Acknowledgment',
      content:
        'By proceeding to log in, you confirm that you have read, understood, and agreed to these Terms and Conditions. For any questions or concerns, please contact help@homahealth.us.',
    },
  ],
};

export default termsConstants;
